<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14Jj1uw/tc-custom/9781788632515.jpg?1704310767319" alt="This image is the cover for the book Sword and the Throne, The Aulus Severus Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sword and the Throne, The Aulus Severus Adventures
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>As Rome enters the Year of the Four Emperors, a soldier marches into the crucible of battle to meet his uncertain fate in the sequel to <i>The Last Caesar</i>.</b></p><p><i>Rome, 69 AD</i>: In the bloody contest for control of Rome, Aulus Caecina Severus has thrown in his lot with the hedonistic military commander Vitellius. Now he must prepare his legions for a grueling march over the Alps. </p><p> Severus leads his army against barbarian rebellions and the tough mountain passes in his race to reach Italy before his rival Valens. With the Po valley almost in sight, news comes that Emperor Galba has been killed in a coup, and that Otho has been declared Emperor by the Praetorians. </p> But there is no turning back for Severus: the Rhine legions want their man on the throne, leading Severus down a dark path. Politics is the new battleground, and Severus needs the help of his wife Salonina and his freedman Totavalas if he wants to survive. And as a new power emerges in the east, Severus must decide where his true loyalty lies . . . 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Venmore-Rowland
      </h2>
      
      <p class="authorDescription body article"><P>Henry Venmore-Rowland was born and bred in Suffolk and graduated from Oxford with a degree in Ancient &amp; Modern History. <I>The Last Caesar</I> (Canelo), his astonishingly mature first novel, is a wonderfully readable story of military action and high political intrigue in Nero’s last year as Emperor. Its narrator, Aulus Caecina Severus, is an ambitious soldier who is wickedly honest about himself and the corruption involved in attaining “the purple”. <I>The Sword and the Throne</I> (Canelo) concludes his adventures in the Year of the Four Emperors.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02c11600